module.exports = __webpack_public_path__ + "img/fruit_grape.d631b3dc.png";